import React from 'react';


// import HintPopover from "core/gd-ui/hint-popover/hint-popover";

import Classes from 'classnames';
import HintPopover from "../../../gd-ui/hint-popover/hint-popover";

type Props = {
    className?: string
    size?: 'big' | '60' | 'normal' | 'small' | 'smaller' | 'tiny' | '26' | '22' |  '30'
    hint?: boolean
    hintNew?: boolean
    blackWhite?: boolean
    style?: React.CSSProperties

    user?: any
    userId?: ID

    onClick?: callback

    renderMom?: boolean

    actionRequired?: boolean          // if set to true ar icon (!) will be added
};

// DEPRICATED ????

export default class UserIconDeprecated extends React.Component<Props> {

    // static propTypes = {
    //     size: PropTypes.oneOf(['big','60','normal','small','smaller','tiny','26','22', '30']),
    //     hint: PropTypes.bool,
    //     hintNew: PropTypes.bool,
    //     blackWhite: PropTypes.bool,
    //     style: PropTypes.object,
    //
    //     user: PropTypes.object,
    //     userId: PropTypes.string,
    //
    //     onClick: PropTypes.func,
    //
    //     actionRequired: PropTypes.bool          // if set to true ar icon (!) will be added
    // };

    static defaultProps = {
        size: 'normal',
        hint: true,
        blackWhite: false,
        renderMom: false,
        actionRequired: false
    };

    renderMom = () => {
        const { renderMom, size, blackWhite, style, onClick, className } = this.props;

        if (!renderMom) return false;

        let iconPath;
        let iconClass;

        switch (size) {
            case 'big':     iconClass = "avatar-big"; break;        // 110px
            case '60':      iconClass = "avatar-60"; break;         // 60px
            case 'normal':  iconClass = "avatar-normal"; break;     // 42px
            case 'small':   iconClass = "avatar-small"; break;      // 36px
            case 'smaller': iconClass = "avatar-smaller"; break;    // 32px
            case 'tiny':    iconClass = "avatar-tiny"; break;       // 26px
            case '26':      iconClass = "avatar-26"; break;         // 26px
            case '22':      iconClass = "avatar-22"; break;         // 22px
            case '30':      iconClass = "avatar-30"; break;         // 30px
            default:
                return false;
        }

        iconPath = gdConfig.assetsPath +'/skin/common/svg/gd-avatar.svg';

        const classes = Classes(iconClass, "mom", className, {
            'b-w': blackWhite
        });

        return (
            <img src={iconPath}
                 alt=''
                 className={classes}
                 onClick={onClick}
                 onDragStart={()=>false}
                 style={style}/>
        );
    };

    render() {
        // ####
        // PATHCH hint not working break wveyrhint !!!
        let hint = false;
        // ####


        let result;
        let iconUser = (!this.props.user && this.props.userId) ? gd.session.users.get(this.props.userId) : this.props.user;
        let iconPath, iconClass;

        if (!iconUser || !iconUser.name) return this.renderMom();


        // Compamy user (not activated
        const companyUser = gd.session.companyUsers.get(gd.companyId+'-'+iconUser.id)
        const notActivated = !companyUser || !companyUser.isActivated


        // No Icon render
        if (!iconUser.icon || iconUser.icon === '_def.jpeg' || notActivated) {

            let colorLetter = iconUser.initials[0].toLowerCase();
            if (colorLetter.match(/[^a-z0-9]/)) {
                colorLetter = 'a'; // not latin / digit... set to default "a" potom nado pomenayt' na raznie simvoli konechno
            }

            const classes = Classes('avatar-'+this.props.size, 'no-icon', 's'+iconUser.initials.length, 'gd-'+colorLetter, this.props.className, {
                'b-w': this.props.blackWhite,
                "i5-user": notActivated,
                'hint--top': hint
            });

            result = (
                <div className={classes} onClick={this.props.onClick} data-hint={hint ? iconUser.name : null}>
                    {!notActivated && iconUser.initials}
                    {this.props.hintNew && <HintPopover parent={this} hint={iconUser.name}/>}
                </div>
            )
        } else {
            switch (this.props.size) {
                case 'big':
                    iconPath = gdConfig.mediaPath +"user/large/" + iconUser.icon;
                    iconClass = "avatar-big";
                    break;
                case '60':
                    iconPath = gdConfig.mediaPath +"user/large/" + iconUser.icon;
                    iconClass = "avatar-60";
                    break;
                case '22':
                    iconPath = gdConfig.mediaPath +"user/norm/" + iconUser.icon;
                    iconClass = "avatar-22";
                    break;
                case '26':
                    iconPath = gdConfig.mediaPath +"user/norm/" + iconUser.icon;
                    iconClass = "avatar-26";
                    break;
                case '30':
                    iconPath = gdConfig.mediaPath +"user/norm/" + iconUser.icon;
                    iconClass = "avatar-30";
                    break;
                case 'normal':
                    iconPath = "/media/user/norm/" + iconUser.icon;
                    iconPath = gdConfig.mediaPath + "user/norm/" + iconUser.icon;
                    iconClass = "avatar-normal";
                    break;
                case 'small':
                    iconPath = gdConfig.mediaPath+"user/norm/" + iconUser.icon;
                    iconClass = "avatar-small";
                    break;
                case 'smaller':
                    iconPath = gdConfig.mediaPath + "user/norm/" + iconUser.icon;
                    iconClass = "avatar-smaller";
                    break;
                case 'tiny':
                    iconPath = gdConfig.mediaPath + "user/norm/" + iconUser.icon;
                    iconClass = "avatar-tiny";
                    break;
                default:
                    console.error("unknown size");
                    return false;
            }

            let specialIconClass = null;
            if (this.props.actionRequired && !hint) {
                specialIconClass = 'ar';
            }

            const classesWithIcon = Classes(iconClass, this.props.className, specialIconClass, {
                'b-w': this.props.blackWhite,
                'hint--top': hint
            });

            if (hint) {
                result = (
                    <span className={classesWithIcon} data-hint={hint ? iconUser.name : null} onClick={this.props.onClick} style={this.props.style}>
                        <img src={iconPath} alt='' className={iconClass}/>
                    </span>
                )
            } else {
                result = (
                    <React.Fragment>
                        <img src={iconPath} alt='' className={classesWithIcon} onClick={this.props.onClick} style={this.props.style}/>
                        {this.props.hintNew && <HintPopover parent={this} hint={iconUser.name}/>}
                    </React.Fragment>
                );
            }
        }

        return result;
    }
}
